import React, { useEffect } from 'react';
import { ErrorMessage, IconSize, IconType, RotatingIcon, SpaceWrapper } from 'ui-toolkit';
import { TitleSummaryCard } from '../../components/clientPortal/TitleSummaryCard';
import { RootStore } from 'store/types';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from 'store/store';
import { getClientOrderAction } from 'store/clientPortal/clientOrderSlice';
import { useKeyToSelect } from 'store/createKeyedDataAsyncSlice';
import { CoverWrapper } from 'ui-toolkit/components/Cover/CoverWrapper';
import { getClientTitleAction } from 'store/clientPortal/clientTitleSlice';
import ClientOrderHeaderApp from '../../components/clientPortal/clientOrderHeader/ClientOrderHeaderApp';

export const ClientTitleTab: React.FC = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const dispatch = useAppDispatch();

  const { data, fetchError } = useKeyToSelect(orderId, ({ clientPortal }: RootStore) => clientPortal.clientOrder);

  const {
    data: titleData,
    fetchStatus: titleFetchStatus,
    fetchError: titleFetchError,
  } = useKeyToSelect(orderId, (store: RootStore) => store.clientPortal.clientTitle);

  useEffect(() => {
    dispatch(getClientOrderAction(orderId));
    dispatch(getClientTitleAction(orderId));
  }, [dispatch, orderId]);

  return (
    <CoverWrapper
      showCover={titleFetchStatus.fetching}
      coverMessage={<RotatingIcon type={IconType.Loading} size={IconSize.Large} />}
    >
      <ErrorMessage error={fetchError || titleFetchError} />
      <ClientOrderHeaderApp order={data} />
      <SpaceWrapper>
        <TitleSummaryCard {...titleData} />
      </SpaceWrapper>
    </CoverWrapper>
  );
};
